import { Route as RouteData } from '../../types/route';
import { USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import { RootPage } from '../components/Pages/RootPage';
import AboutSection from '../components/Sections/AboutSection';
import HomeSection from '../components/Sections/HomeSection';
import GallectionsSection from '../components/Sections/GallectionsSection';
import ShopSection from '../components/Sections/ShopSection';
import PostsSection from '../components/Sections/PostsSection';
import StatsSection from '../components/Sections/StatsSection';

export const sectionRoutes = [
  {
    key: 'about',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.ABOUT}`,
    component: AboutSection,
    exact: true,
    loaderName: 'about',
  },
  {
    key: 'home',
    path: '/:username',
    component: HomeSection,
    loaderName: 'home',
    exact: true,
  },
  {
    key: 'gallery',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.GALLERY}/:folderId(\\d+)?/:folderName?`,
    component: GallectionsSection,
    loaderName: 'gallery',
    exact: false,
  },
  {
    key: 'favourites',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.FAVOURITES}/:folderId(\\d+)?/:folderName?`,
    component: GallectionsSection,
    loaderName: 'favourites',
    exact: false,
  },
  {
    key: 'posts',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.POSTS}/:postsSection?/:sortOrder?`,
    component: PostsSection,
    loaderName: 'posts',
    exact: false,
  },
  {
    key: 'shop',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.SHOP}/:shopSection?`,
    component: ShopSection,
    loaderName: 'shop',
    exact: false,
  },
  {
    /** If we change this key, be sure to update where we reference it (translations, SubNavBarDesktop) */
    key: 'stats',
    path: `/:username/${USER_PROFILE_SECTION_PATHS.STATS}`,
    component: StatsSection,
    loaderName: 'stats',
    isForOwnerOnly: true,
    featureProtected: 'stats',
    isBeta: true,
    exact: true,
  },
];

export const routes = [
  {
    key: 'root',
    component: RootPage,
    routes: sectionRoutes,
  },
] as RouteData[];

export const getSectionKeys = () => sectionRoutes.map(v => v.key);
